import css from "PFApp/hooks/activity_form/multi_roles_form/use_actions_column/actions_cell.module.scss";
import { RoleFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { ColumnHelper } from "PFComponents/table/table.types";
import { useCallback } from "react";

import { ManageRolesActionType } from "../manage_roles.types";
import { ManageRolesActionsCell } from "../parts/manage_roles_actions_cell";

type UseManageRolesActionsColumnProps = {
  onChange: (roleFormKey: RoleFormKey, action: ManageRolesActionType) => void;
};

export const useManageRolesActionsColumn = <DATA extends { roleFormKey?: RoleFormKey }>({
  onChange
}: UseManageRolesActionsColumnProps) =>
  useCallback(
    (columnHelper: ColumnHelper<DATA>) =>
      columnHelper.accessor((row) => row, {
        id: "actions",
        header: "",
        cell: (info) => (
          <ManageRolesActionsCell
            roleFormKey={info.row.original.roleFormKey as RoleFormKey}
            onChange={onChange}
          />
        ),
        size: 32,
        enableSorting: false,
        meta: {
          sticky: true,
          cellClassName: css.actionsCell
        }
      }),
    [onChange]
  );
